import { commonChecks } from '@xhs/ozone-detector'

import { closeWindow, changeTitle } from '../ui'
import { changeTitle as changeTitleMp } from '../libs/mpBridge'

import { appVersionLt, appVersionEq } from '../libs/version'

import completeUrl from '../utils/completeUrl'

function installPolyfill() {
  if (!process.env.BROWSER) {
    return
  }

  if (commonChecks.isMiniprogram) {
    Object.defineProperty(document, 'title', {
      set(title) {
        this._title = title // eslint-disable-line no-underscore-dangle
        changeTitleMp(title)
      },
      get() {
        return this._title // eslint-disable-line no-underscore-dangle
      },
      configurable: true,
    })

    return
  }

  if (!commonChecks.isXHS) {
    return
  }

  if (appVersionLt('6.36')) {
    window.open = function windowOpen(link) {
      if (['redtop://', 'uniik://'].some(protocol => link?.startsWith(protocol))) {
        window.location.href = link
      } else {
        const url = new URL(completeUrl(link))

        url.searchParams.set('openPage', 'yes')

        window.location.href = url.toString()
      }
    }
  }

  window.close = function windowClose() {
    closeWindow()
  }

  if (commonChecks.isAndroid) {
    if (appVersionEq('6.61')) {
      if (!window.XHSEvents) {
        window.XHSEvents = {}
      }
    }

    if (appVersionLt('6.54')) {
      Object.defineProperty(document, 'title', {
        set(title) {
          this._title = title // eslint-disable-line no-underscore-dangle
          changeTitle(title)
        },
        get() {
          return this._title // eslint-disable-line no-underscore-dangle
        },
        configurable: true,
      })
    }
  }
}

installPolyfill()
